import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface AnalyzeResultsParams {
  patientId?: string;
}

interface AnalyzeResultsResponse {
  success: boolean;
  updated: number;
  skipped: number;
  total: number;
}

export function useAnalyzeResults() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ patientId }: AnalyzeResultsParams): Promise<AnalyzeResultsResponse> => {
      console.log(`🔬 Starting analysis for patient ${patientId ?? 'all'}...`);

      const { data, error } = await supabase.functions.invoke("analyze-results", {
        body: { patient_id: patientId ?? null },
      });

      if (error) {
        console.error("❌ Error analyzing results:", error);
        throw error;
      }

      console.log("✅ Analysis completed:", data);
      return data as AnalyzeResultsResponse;
    },
    onSuccess: (data, variables) => {
      if (variables.patientId) {
        queryClient.invalidateQueries({ queryKey: ["lab-results", variables.patientId] });
        queryClient.invalidateQueries({ queryKey: ["patient", variables.patientId] });
      }
      queryClient.invalidateQueries({ queryKey: ["lab-subcategories"] });

      toast.success(
        `✅ Análise concluída\n${data.updated} atualizado(s) • ${data.skipped} sem alteração • ${data.total} processado(s)`
      );
    },
    onError: (error: any) => {
      console.error("❌ Mutation error:", error);
      const msg = error?.message || error?.error || "Falha ao analisar resultados. Tente novamente.";
      toast.error(msg);
    },
  });
}
